import { render } from "./Department_Administrat.vue?vue&type=template&id=3b12f578&scoped=true"
import script from "./Department_Administrat.vue?vue&type=script&lang=js"
export * from "./Department_Administrat.vue?vue&type=script&lang=js"

import "./Department_Administrat.vue?vue&type=style&index=0&id=3b12f578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b12f578"]])

export default __exports__